import { useRosterFocusStore } from "@/store/rosterFocusStore";

function ShiftCode({ code, color }: { code: string; color: string }) {
  const columnKey = `shift${code}`;
  const isHovered = useRosterFocusStore((s) => s.hoveredColumn === columnKey);
  const isSelected = useRosterFocusStore((s) => s.selectedColumn === columnKey);
  const setHoveredFocus = useRosterFocusStore((s) => s.setHoveredFocus);
  const clearHoveredFocus = useRosterFocusStore((s) => s.clearHoveredFocus);

  const highlightBg = isSelected
    ? "rgba(169, 223, 254, 0.4)"
    : isHovered
      ? "rgba(169, 223, 254, 0.3)"
      : undefined;

  return (
    <div
      data-column={columnKey}
      style={highlightBg != null ? { backgroundColor: highlightBg } : undefined}
    >
      <div
        className="text-[15px] text-white flex items-center justify-center font-semibold border-border aspect-square w-7 rounded-[5px] border "
        style={{ backgroundColor: color }}
        onMouseEnter={() => {
          setHoveredFocus({ column: columnKey, nurseId: "" });
        }}
        onMouseLeave={() => {
          clearHoveredFocus();
        }}
      >
        <span className="truncate">{code}</span>
      </div>
    </div>
  );
}

export default ShiftCode;
